// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"255":"36d142bae1c99f8d","301":"4b364a9414bb6580"}[chunkId] + ".css";
};